/**
 * This file is generated by `pnpm codegen` from the OpenAPI spec, DO NOT EDIT.
 */

import makeMutationHook from 'core/types/makeMutationHook'
import makeQueryHook from 'core/types/makeQueryHook'
import * as operations from 'core/types/operations'

export const useCreditAgenciesList = makeQueryHook(
  operations.creditAgenciesList,
)

export const useCreditAgencyCreate = makeMutationHook(
  operations.creditAgencyCreate,
)

export const useReportedLoans = makeQueryHook(operations.reportedLoans)

export const useCreditAgencyGet = makeQueryHook(operations.creditAgencyGet)

export const useCreditAgencyUpdate = makeMutationHook(
  operations.creditAgencyUpdate,
)

export const useCreditAgencyRegenerateSshKeys = makeMutationHook(
  operations.creditAgencyRegenerateSshKeys,
)

export const useInternalCreditReportingStatusDelete = makeMutationHook(
  operations.internalCreditReportingStatusDelete,
)

export const useGenerateMetro2Files = makeMutationHook(
  operations.generateMetro2Files,
)

export const useCreditReportingStatusesList = makeQueryHook(
  operations.creditReportingStatusesList,
)

export const useCreditReportingFieldsUpdate = makeMutationHook(
  operations.creditReportingFieldsUpdate,
)

export const useCreditReportingStatusCreate = makeMutationHook(
  operations.creditReportingStatusCreate,
)

export const useCreditReportingStatusDelete = makeMutationHook(
  operations.creditReportingStatusDelete,
)

export const useGetMetro2Data = makeQueryHook(operations.getMetro2Data)

export const useFileCreationRecordCreate = makeMutationHook(
  operations.fileCreationRecordCreate,
)
